/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentreporter": {
        "nested": {
          "report": {
            "nested": {
              "feereport": {
                "nested": {
                  "FeeType": {
                    "values": {
                      "FEE_TYPE_DO_NOT_USE": 0,
                      "CARD_FEES": 1,
                      "AFTERPAY_FEES": 2,
                      "ACH_FEES": 3,
                      "THIRD_PARTY_FEES": 4,
                      "DELIVERY_FEES": 5,
                      "INSTANT_TRANSFER_FEES": 6,
                      "CASH_APP_FEES": 7,
                      "NETWORK_FEES": 8,
                      "SETTLEMENT_FEES": 9,
                      "GIFT_CARD_LOAD_FEES": 10,
                      "ADDITIONAL_FEES": 11,
                      "EMONEY_FEES": 12,
                      "D_BARAI_FEES": 13,
                      "MERPAY_FEES": 14,
                      "PAYPAY_FEES": 15,
                      "RAKUTEN_PAY_FEES": 16,
                      "WECHAT_PAY_FEES": 17,
                      "AU_PAY_FEES": 18
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentreporter?.nested?.report?.nested?.feereport?.nested?.FeeType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FeeType @ squareup/paymentreporter/report/fee_report.proto at 44:1
 */
export const FeeType = $root.lookupEnum('squareup.paymentreporter.report.feereport.FeeType').values;